import React from "react";
import { Container } from "react-bootstrap";
import classes from './text.module.css';
import Text from "./Text";

const TextCol = ({texts, title}) => {
    return (
        <Container fluid="md">
            <h1>{title}</h1>
            <div className={classes.textCol}>
                {texts.map((text, index) => 
                    <Text number={index +1} text={text} key={text.id} />
                )}
            </div>
        </Container>
    )
}

export default TextCol;